// extracted by mini-css-extract-plugin
module.exports = {"container":"select_container__CbMAm","control":"select_control__ZJ80W","menu":"select_menu__2pPnd","SelectTextLabel":"select_SelectTextLabel__cr6L3"};